<template>
  <div class="card">
    <div class="card-header">
      {{ name }}
    </div>
    <div class="card-body">
      <div class="card-block spinner-parent">
        <spinner ref="spinner" size="md" text="Loading ..." />

        <table class="table table-bordered table-striped table-sm">
          <thead>
            <tr>
              <th>ID</th>
              <th>Title</th>
              <th>Content type</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="currentContent.length === 0">
              <td colspan="4">No featured content for this section</td>
            </tr>
            <tr v-for="item in currentContent" :id="`article${item.id}`" :key="`${item.type}_${item.id}`">
              <td>{{ item.id }}</td>
              <td>{{ item.title }}</td>
              <td>{{ item.type }}</td>
              <td class="table-list__cell--narrow">
                <router-link
                  :to="`/admin/content/${item.type}/edit/${item.id}`"
                  class="btn btn-primary btn-sm"
                  exact
                >
                  Edit
                </router-link>
                <button class="btn btn-danger btn-sm" @click="dettachContent(item)">
                  Dettach
                  <span class="btn-loader" style="display: none" />
                </button>
                <open-on-site
                  :source-route="item.route"
                />
              </td>
            </tr>
          </tbody>
        </table>

        <div class="row">
          <div class="col-md-6">
            <label>Add Url</label>
            <input v-model="newContentUrl" type="text" class="form-control mb-3" @keydown.enter="addNewUrl">
            <div v-if="newContentUrl" class="form-group">
              <button class="btn btn-success" @click="addNewUrl">
                Add
                <span v-if="newUrlLoader" ref="addUrlLoader" class="btn-loader" />
              </button>
            </div>
            <div v-show="saveUrlErrorMessage" class="saving-alerts">
              <div class="alert alert-danger">
                {{ saveUrlErrorMessage }}
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <label>Add Content</label>
            <vue-select
              v-model="contentType"
              :options="contentTypeOptions"
              class="mb-3"
            />
            <vue-select
              v-if="contentType"
              ref="contentEntityModel"
              v-model="contentEntity"
              :filterable="false"
              :options="contentEntityOptions"
              label="id"
              class="mb-3"
              @search="onEntitySearch"
            >
              <template slot="no-options">
                type to search...
              </template>
              <template slot="option" slot-scope="option">
                {{ option.title }}
              </template>
              <template slot="selected-option" slot-scope="option">
                {{ option.title }}
              </template>
            </vue-select>

            <div v-if="contentEntity" class="form-group">
              <button class="btn btn-success" @click="addContent">
                Add
                <span v-if="newContentLoader" ref="addContentLoader" class="btn-loader" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import VueSelect from 'vue-select';
import OpenOnSiteButton from '@/global/components/OpenOnSiteButton';

export default {
  components: {
    'vue-select': VueSelect,
    'open-on-site': OpenOnSiteButton,
  },

  props: {
    name: {
      type: String,
      default: '',
    },
    id: {
      type: Number,
      required: true,
    },
    contentProps: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    newUrlLoader: false,
    newContentLoader: false,
    currentContent: [],
    newContentUrl: '',
    contentType: null,
    contentEntityOptions: [],
    contentEntity: null,
    saveUrlErrorMessage: '',
  }),

  computed: {
    contentTypeOptions() {
      const array = [];
      _.forEach(this.$store.state.contentTypes.list, (item, key) => {
        array.push({
          label: this.snakeToTitle(key),
          key,
        });
      });
      return array;
    },
  },

  watch: {
    contentType() {
      this.contentEntityOptions = [];
      this.contentEntity = null;
      if (this.$refs.contentEntityModel) {
        this.$refs.contentEntityModel.onEscape();
      }
    },
    contentProps(val) {
      this.currentContent = val;
    },
    loading(val) {
      if (this.$refs.spinner) {
        if (val) {
          this.$refs.spinner.show();
        } else {
          this.$refs.spinner.hide();
        }
      }
    },
  },

  mounted() {
    this.currentContent = this.contentProps;
    if (this.$refs.spinner && this.loading) {
      this.$refs.spinner.show();
    }
  },

  methods: {
    snakeToTitle(str) {
      return str.split('_').map(item => item.charAt(0).toUpperCase() + item.substring(1)).join(' ');
    },
    dettachContent(content) {
      if (window.confirm(`Do you really want to make article with id "${content.id}" non featured?`)) {
        const $btnLoader = $(`#article${content.id} .btn-danger .btn-loader`);
        $btnLoader.show();
        const contentList = _.cloneDeep(this.currentContent);
        _.remove(contentList, item => item.id === content.id && item.type === content.type);

        this.$apiHttp.post(`${this.$config.app_api.prefix}featured-content/unfeature`, {
          block_id: this.id,
          alias: content.type,
          id: content.id,
        }).then(() => {
          this.currentContent = contentList;
          $btnLoader.hide();
        }).catch((error) => {
          $btnLoader.hide();
          this.$store.dispatch('notifications/setHttpError', { error, text: 'Error in unfeaturing content request' });
          console.error(error);
        });
      }
    },
    addContent() {
      if (this.newContentLoader) return;
      this.newContentLoader = true;
      this.$apiHttp.post(`${this.$config.app_api.prefix}featured-content/feature`, {
        section_id: this.id,
        alias: this.contentType.key,
        id: this.contentEntity.id,
      }).then((response) => {
        this.contentEntity = null;
        this.newContentLoader = false;
        const { id, type } = response.data;
        if (!_.find(this.currentContent, item => item.id === id && item.type === type)) {
          this.currentContent.push(response.data);
        }
      }).catch((error) => {
        this.newContentLoader = false;
        this.$store.dispatch('notifications/setHttpError', { error, text: 'Error in adding content request' });
        console.error(error);
      });
    },
    addNewUrl() {
      if (this.newUrlLoader) return;
      this.saveUrlErrorMessage = '';
      this.newUrlLoader = true;
      this.$apiHttp.post(`${this.$config.app_api.prefix}featured-content/feature-by-url`, {
        section_id: this.id,
        url: this.newContentUrl,
      }).then((response) => {
        this.newContentUrl = '';
        this.newUrlLoader = false;
        const { id, type } = response.data;
        if (!_.find(this.currentContent, item => item.id === id && item.type === type)) {
          this.currentContent.push(response.data);
        }
      }).catch((error) => {
        let errorText = '';
        this.newUrlLoader = false;
        if (_.has(error, 'response.data.message') && error.response.data.message) {
          errorText = error.response.data.message;
        } else {
          errorText = 'Server error';
        }
        this.saveUrlErrorMessage = errorText;
        this.$store.dispatch('notifications/setHttpError', { error, text: errorText });
        console.error(error);
      });
    },
    onEntitySearch(search, loading) {
      loading(true);
      this.entitySearch(loading, search, this, this.contentType.key);
    },
    entitySearch: _.debounce((loading, search, vm, contentType) => {
      const context = vm;
      vm.$apiHttp.get(`${vm.$config.app_api.host + vm.$config.app_api.prefix}content-types/${contentType}`, {
        params: {
          search_string: escape(search),
        },
      }).then((response) => {
        const newDataArr = [];
        _.forIn(response.data, (value, key) => {
          if (key !== 'meta') {
            newDataArr.push(value);
          }
        });
        context.contentEntityOptions = newDataArr;
        loading(false);
      }).catch((reject) => {
        console.error(reject);
      });
    }, 350),
  },
};
</script>



// WEBPACK FOOTER //
// HomeSection.vue?f3628c9c